import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type BalanceData} from './balance';

export function balancePatcher(data: BalanceData): RestTypeWithTypename<BalanceData> {
    return {
        __typename: 'BalanceData',
        ...data,
        items: data.items?.map(i => ({__typename: 'BalanceItem', ...i})),
        behaviors: data.behaviors?.map(b => ({__typename: 'BalanceBehavior', ...b})),
    };
}
